export * from './characteristics';
export * from './energy-label';
export * from './reparability';
